import React from "react";
import { MapPinned } from "lucide-react";

const countries = [
  { name: "Trinidad & Tobago", flag: "🇹🇹" },
  { name: "Jamaica", flag: "🇯🇲" },
  { name: "Barbados", flag: "🇧🇧" },
  { name: "More soon", flag: "✦" },
];

export const Coverage = () => {
  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="liea-section"
      style={{
        background:
          "linear-gradient(180deg, var(--liea-cream-soft) 0%, var(--liea-paper) 100%)",
      }}
    >
      <div className="liea-container">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 liea-eyebrow">
            <MapPinned size={14} />
            Where Liéa operates
          </div>
          <h2 className="mt-4 text-[34px] md:text-[44px] lg:text-[52px] leading-[1.05] tracking-tight">
            Rooted in the Caribbean
            <span style={{ color: "var(--liea-terracotta)" }}>.</span>{" "}
            <em
              style={{
                fontStyle: "italic",
                color: "var(--liea-forest)",
              }}
            >
              Growing outward.
            </em>
          </h2>
          <p
            className="mt-5 text-base md:text-lg leading-relaxed"
            style={{ color: "var(--liea-warm-grey)" }}
          >
            Today, Liéa connects families across the Caribbean, with a real
            network of local vendors who know their neighbourhoods. New
            countries are added as our vendor community grows.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
          {countries.map((c) => (
            <span
              key={c.name}
              data-testid={`coverage-chip-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="liea-chip"
            >
              <span aria-hidden="true">{c.flag}</span>
              {c.name}
            </span>
          ))}
        </div>

        <div
          className="mt-14 mx-auto max-w-3xl rounded-3xl p-10 md:p-14 text-center"
          style={{
            background: "#ffffff",
            border: "1px solid rgba(149, 159, 133, 0.22)",
          }}
        >
          <p
            className="font-serif text-[24px] md:text-[30px] leading-snug italic"
            style={{ color: "var(--liea-ink)" }}
          >
            &ldquo;Distance shouldn&rsquo;t change how loved someone feels on
            their day.&rdquo;
          </p>
          <p
            className="mt-4 text-xs uppercase tracking-[0.22em]"
            style={{ color: "var(--liea-sage)" }}
          >
           , The Liéa team
          </p>
        </div>
      </div>
    </section>
  );
};

export default Coverage;
